module.exports = __webpack_public_path__ + "img/project1_2.png.8d67dbb0.webp";